import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useConnection(userID) {
  const { data, error, _isLoading, mutate } = useSWR(
    userID ? `/users/expired` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return { data: data, error: error, mutate: mutate };
}

export default useConnection;
